import { useState } from 'react'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { updateReplyMessage } from '../../actions';
import { STORE } from '../../store';

export default function MessageActions(props: any) {
  const { message, show } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const isLiveChatActive = !!localStorage.getItem('agentId');
  const handleOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (action: 'reply' | 'copy') => {
    if (action === 'copy') {
      const text = message?.text || message?.label;
      navigator.clipboard.writeText(text);
    } else if (action === 'reply') {
      STORE.dispatch(updateReplyMessage(message));
    }
    handleClose();
  }

  return (
    isLiveChatActive
      ? <div className="ele-message-action absolute right-1 text-white top-1 cursor-pointer">
        {((show || open) &&
          <div className='ele-message-action-options h-8 w-8 bg-white text-center rounded-full flex items-center justify-center hover:border'>
            <MoreVertIcon
              onClick={handleOpen}
              fontSize="medium"
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              className={`text-primaryText`}
            />
          </div>
        )}
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={() => handleClick('reply')}>
            <span className="font-mRegular text-primaryText text-sm"> Reply</span>
          </MenuItem>
          <MenuItem onClick={() => handleClick('copy')}>
            <span className="font-mRegular text-primaryTex text-sm">Copy</span>
          </MenuItem>
        </Menu>
      </div>
      : null
  );
}